import env from 'utils/env';
import createApiUrlProvider from 'utils/apiUrlProvider';
const apiUrlProvider = createApiUrlProvider();

export const PAYMENT_CHECKOUT = 'PAYMENT_CHECKOUT';
export const PAYMENT_STRIPE_CHECKOUT = 'PAYMENT_STRIPE_CHECKOUT';
export const REQUEST_PLACED_PAYMENT = 'REQUEST_PLACED_PAYMENT';
export const REQUEST_PAYMENT_METHOD = 'REQUEST_PAYMENT_METHOD';
export const REQUEST_PAYMENT_CONFIRM = 'REQUEST_PAYMENT_CONFIRM';
export const REQUEST_CHECK_QR = 'REQUEST_CHECK_QR';
export const REQUEST_QR_PAYMENT = 'REQUEST_QR_PAYMENT';
export const REQUEST_RECEIPT = 'REQUEST_RECEIPT';
export const REQUEST_SEND_RECEIPT = 'REQUEST_SEND_RECEIPT';
export const REQUEST_SEND_RECEIPT_CASHBACK = 'REQUEST_SEND_RECEIPT_CASHBACK';
export const REQUEST_COLLECT_LOYALTY = 'REQUEST_COLLECT_LOYALTY';
export const REQUEST_LOYALTY_ACTIVITY = 'REQUEST_LOYALTY_ACTIVITY';
export const REQUEST_LOYALTY = 'REQUEST_LOYALTY';
export const REQUEST_UPDATE_PAY_LATER = 'REQUEST_UPDATE_PAY_LATER';
export const REQUEST_CURRENT_RESERVE_LOYALTY = 'REQUEST_CURRENT_RESERVE_LOYALTY';
export const REQUEST_AMOUNT_LESS = 'REQUEST_AMOUNT_LESS';
export const GET_AMOUNT_LESS_MERCHANT_DETAIL = 'GET_AMOUNT_LESS_MERCHANT_DETAIL';
export const ORACLE_GET_BILLS = 'ORACLE_GET_BILLS';
export const ORACLE_GET_DETAILS = 'ORACLE_GET_DETAILS';
export const ORACLE_PAYMENT_REQUEST = 'ORACLE_PAYMENT_REQUEST';
export const CLEAR_COUPON = 'CLEAR_COUPON';
export const APPLY_COUPON = 'REQUEST_COUPON';
export const APPLY_HAPPY_HOUR = 'APPLY_HAPPY_HOUR';
export const APPLY_FREE_PAYMENT = 'APPLY_FREE_PAYMENT';
export const REQUEST_SETUP_CONTINENT_FEE = 'REQUEST_SETUP_CONTINENT_FEE';
export const REQUEST_SUBSCRIBE_PAYMENT_EMAIL = 'REQUEST_SUBSCRIBE_PAYMENT_EMAIL';
export const REQUEST_CHARGE_TO_ROOM = 'REQUEST_CHARGE_TO_ROOM';
export const VERIFY_PAYMENT_THIRD_CONNECT = 'VERIFY_PAYMENT_THIRD_CONNECT';
export const REQUEST_ADYEN_PAYMENT = 'REQUEST_ADYEN_PAYMENT';
export const REQUEST_ADYEN_PAYMENT_CONFIRM = 'REQUEST_ADYEN_PAYMENT_CONFIRM';
export const REQUEST_ADYEN_PAYMENT_METHODS = 'REQUEST_ADYEN_PAYMENT_METHODS';
export const SHOP_DETAIL = 'SHOP_DETAIL';
export const SHOP_PRODUCTS = 'SHOP_PRODUCTS';
export const SHOP_PRODUCT_IMAGE = 'SHOP_PRODUCT_IMAGE';
export const SHOP_LOGO = 'SHOP_LOGO';
export const SHOP_CHECKOUT = 'SHOP_CHECKOUT';

export const VOUCHER_APPLY = 'VOUCHER_APPLY';
export const VOUCHER_CLEAR = 'VOUCHER_CLEAR';
export const VOUCHER_PAY = 'VOUCHER_PAY';

// NOTE Split bill
export const UPDATE_TOTAL_SPLITBILL = 'UPDATE_TOTAL_SPLITBILL';
export const REQUEST_REMAINING_SPLIT_BILL = 'REQUEST_REMAINING_SPLIT_BILL';
export const GET_ITEMS = 'GET_ITEMS';
export const SPLIT_ITEMS = 'SPLIT_ITEMS';
export const SPLIT_CHECKOUT_ITEM = 'SPLIT_CHECKOUT_ITEM';
export const SEND_TRANSFER = 'SEND_TRANSFER';
export const UPDATE_TRANSFER = 'UPDATE_TRANSFER';
export const CONFIRM_SPLIT_PAYMENT = 'CONFIRM_SPLIT_PAYMENT';
export const PAY_OTHER_ITEMS = 'PAY_OTHER_ITEMS';
export const UPDATE_PAY_OTHER = 'UPDATE_PAY_OTHER';

apiUrlProvider.setBaseUrl(`${env.get('API_URL')}/`);
apiUrlProvider.set(REQUEST_CHARGE_TO_ROOM, '/merchants/third-connect/verify/room');

apiUrlProvider.setBaseUrl(`${env.get('PAYMENT')}/v1/`);
apiUrlProvider.set(CLEAR_COUPON, '/discount/clear');
apiUrlProvider.set(APPLY_COUPON, '/discount/apply');
apiUrlProvider.set(APPLY_HAPPY_HOUR, '/discount/apply-happy-hour');

apiUrlProvider.set(PAYMENT_CHECKOUT, '/payments/checkout');
apiUrlProvider.set(PAYMENT_STRIPE_CHECKOUT, '/payments/stripe/checkout');
apiUrlProvider.set(REQUEST_PAYMENT_METHOD, '/payments/stripe/create');
apiUrlProvider.set(REQUEST_PAYMENT_CONFIRM, '/payments/stripe/confirm');
apiUrlProvider.set(REQUEST_CHECK_QR, '/payment/qr/:id');
apiUrlProvider.set(REQUEST_QR_PAYMENT, '/payment/qr/:id');
apiUrlProvider.set(REQUEST_RECEIPT, '/payments/receipt');
apiUrlProvider.set(REQUEST_SEND_RECEIPT, '/payments/receipt');
apiUrlProvider.set(REQUEST_SEND_RECEIPT_CASHBACK, '/payments/:tx/email');
apiUrlProvider.set(REQUEST_COLLECT_LOYALTY, '/payments/collect-loyalties');
apiUrlProvider.set(REQUEST_LOYALTY_ACTIVITY, '/payments/:phone/loyalty-activities');
apiUrlProvider.set(REQUEST_LOYALTY, '/payments/loyalties');
apiUrlProvider.set(REQUEST_UPDATE_PAY_LATER, '/payment/later/placing-update');
apiUrlProvider.set(REQUEST_CURRENT_RESERVE_LOYALTY, '/payment/current-loyalty-reward');
apiUrlProvider.set(GET_AMOUNT_LESS_MERCHANT_DETAIL, '/placed-payments/merchant-detail');
apiUrlProvider.set(REQUEST_SUBSCRIBE_PAYMENT_EMAIL, '/payments/stripe/subscribe-email');

apiUrlProvider.set(REQUEST_AMOUNT_LESS, '/payment/request/amount-less');
apiUrlProvider.set(ORACLE_PAYMENT_REQUEST, '/oracle-payment/request');

apiUrlProvider.setBaseUrl(`${env.get('API_URL')}/v1/oracle`);

apiUrlProvider.set(ORACLE_GET_BILLS, '/bills');
apiUrlProvider.set(ORACLE_GET_DETAILS, '/merchant/detail');

apiUrlProvider.setBaseUrl(`${env.get('PAYMENT')}/`);

// NOTE : Split bill
apiUrlProvider.set(UPDATE_TOTAL_SPLITBILL, '/split-bill/total');
apiUrlProvider.set(REQUEST_REMAINING_SPLIT_BILL, '/split-bill/remaining');
apiUrlProvider.set(GET_ITEMS, '/split-bill/items');
apiUrlProvider.set(SPLIT_ITEMS, '/split-bill/menu');
apiUrlProvider.set(SPLIT_CHECKOUT_ITEM, '/split-bill/confirm');
apiUrlProvider.set(SEND_TRANSFER, '/split-bill/transfer');
apiUrlProvider.set(UPDATE_TRANSFER, '/split-bill/transfer');
apiUrlProvider.set(CONFIRM_SPLIT_PAYMENT, '/split-bill/confirm-split-payment');
apiUrlProvider.set(PAY_OTHER_ITEMS, '/split-bill/pay-other-items');
apiUrlProvider.set(UPDATE_PAY_OTHER, '/split-bill/pay-other');

apiUrlProvider.set(REQUEST_PLACED_PAYMENT, '/placed-payments');
apiUrlProvider.set(APPLY_FREE_PAYMENT, '/payments/get-free');
apiUrlProvider.set(REQUEST_SETUP_CONTINENT_FEE, '/payments/stripe/setup-fee');

// NOTE : adyen
apiUrlProvider.set(REQUEST_ADYEN_PAYMENT, '/adyen/payment-create');
apiUrlProvider.set(REQUEST_ADYEN_PAYMENT_CONFIRM, '/adyen/confirm-payment');
apiUrlProvider.set(REQUEST_ADYEN_PAYMENT_METHODS, '/adyen/payment-methods');

// NOTE : voucher
apiUrlProvider.set(VOUCHER_APPLY, '/v1/voucher/apply');
apiUrlProvider.set(VOUCHER_CLEAR, '/v1/voucher/clear');
apiUrlProvider.set(VOUCHER_PAY, '/v1/voucher/pay');
apiUrlProvider.setBaseUrl(`${env.get('API_URL')}/`);
apiUrlProvider.set(VERIFY_PAYMENT_THIRD_CONNECT, '/merchants/third-connect/verify-payment');

// NOTE : shop (management service)
apiUrlProvider.set(SHOP_DETAIL, '/shop/:shopCode');
apiUrlProvider.set(SHOP_PRODUCTS, '/shop/:shopCode/products');
apiUrlProvider.set(SHOP_PRODUCT_IMAGE, '/shop/:shopCode/products/:productId/image');
apiUrlProvider.set(SHOP_LOGO, '/shop/:shopCode/logo');
apiUrlProvider.set(SHOP_CHECKOUT, '/shop/:shopCode/checkout');

export default apiUrlProvider;
